export default {
  ADDRESS_DOSE_NOT_EXIST: "آدرس موجود نیست.",
  TITLE_DOSE_NOT_EXIST: "عنوان موجود نیست.",
  IMAGE_DOSE_NOT_EXIST: "هیچ عکسی برای تبلیغ وارد نشده.",

  ADDRESS_INVALID: "آدرس نامعتبر است.",
  TITLE_INVALID: "عنوان نامعتبر است.",
  IMAGE_INVALID: "عکس نامعتبر است.",

  ACTIVE_NOT_EXIST: "فعال بودن تبلیغ موجود نیست.",
  ACTIVE_INVALID: "فعال بودن تبلیغ نامعتبر است.",

  ADD_CAMPAIGN_SUCCESS: "کمپین اضافه شد.",
  ADD_CAMPAIGN_FAILED: "اضافه کردن کمپین با شکست روبرو شد.",

  ID_INVALID: "شماره نامعتبر است..",

  GET_CAMPAIGN_FAILED: "گرفتن کمپین با شکست روبرو شد.",

  DELETE_CAMPAIGN_FAILED: "حذف کمپین با شکست روبرو شد.",
  DELETE_CAMPAIGN_SUCCESS: "کمپین حذف شد.",

  EDIT_CAMPAIGN_FAILED: "ویرایش کمپین با شکست روبرو شد.",
  EDIT_CAMPAIGN_SUCCESS: "کمپین ویرایش شد.",
};
